import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectors } from '@/domains/cabinet';

export const useIsCabinet = () => {
  const { isLoginTerms } = useSelector(selectors.selectCabinet);
  const route = useRouter();

  const [isCabinet, setIsCabinet] = useState(false);
  const isCabinetPage =
    route.pathname.startsWith('/login') ||
    route.pathname.startsWith('/cabinet') ||
    isLoginTerms;

  useEffect(() => {
    setIsCabinet(isCabinetPage);
  }, [isCabinetPage]);

  return isCabinet;
};
